// @flow

import React from "react";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { withStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";
import HelpModal from "routes/private/Help/HelpModal";

const styles = (theme) => ({
  tabs: {
    backgroundColor: theme.palette.background.paper,
    "& button": {
      fontWeight: 400,
      textTransform: "none",
      minHeight: 56,
      "@media (min-width: 0px) and (orientation: landscape)": {
        minHeight: 48,
      },
      "@media (min-width: 600px)": {
        minHeight: 64,
      },
    },
  },
  toolbar: {
    backgroundColor: "#fff",
  },
  button: {
    fontWeight: 400,
    textTransform: "none",
  },
});

type Props = {
  value: string,
  handleChange: Function,
  onButtonClick: (boolean) => void,
  canSeeContest: boolean,
  isAdmin: boolean,
  classes: Object,
  className: string,
};

const BottomToolbar = ({
  value = "/private/dashboard",
  handleChange,
  classes,
  canSeeContest,
  isAdmin,
  onButtonClick,
  className,
}: Props) => {
  const dashboardTabValue = "/private/dashboard";
  const myTeamsTabValue = "/private/myteams";
  const contestsTabValue = "/private/contests";
  const searchTabValue = "/private/search";
  const contactsTabValue = "/community/contacts";

  const tabsValue = [
    dashboardTabValue,
    myTeamsTabValue,
    contestsTabValue,
    searchTabValue,
    contestsTabValue,
  ].includes(value)
    ? value
    : dashboardTabValue;
  return (
    <div className={className}>
      <Toolbar className={classes.toolbar}>
        <Hidden lgUp>
          <IconButton
            aria-label="Main Menu"
            onClick={() => onButtonClick(true)}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
        <Hidden mdDown>
          <IconButton
            aria-label="Main Menu"
            onClick={() => onButtonClick(false)}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
        <Tabs
          className={classes.tabs}
          value={tabsValue}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="Dashboard" value={dashboardTabValue} />
          <Tab label="Teams" value={myTeamsTabValue} />
          {canSeeContest && <Tab label="Contests" value={contestsTabValue} />}
          {isAdmin && <Tab label="Search" value={searchTabValue} />}
          <Tab label="Contacts" value={contactsTabValue} />
        </Tabs>
        <HelpModal />
      </Toolbar>
    </div>
  );
};

export default withStyles(styles)(BottomToolbar);
